import { EntityRequestLoa } from "../../entity/EntityRequestLoa";

export class DtoRequestLoasPutRes extends EntityRequestLoa {}
